/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Station_Voice_Col_ReadsInputs */

const vi_station_voice_col_reads = /** @type {(inputs: Station_Voice_Col_ReadsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đọc gì`)
};

/**

* @param {Station_Voice_Col_ReadsInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const station_voice_col_reads = /** @type {((inputs?: Station_Voice_Col_ReadsInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Station_Voice_Col_ReadsInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_station_voice_col_reads(inputs)
});